module.exports = __webpack_public_path__ + "img/flag-en.9071acd9.png";